var MDL_METHOD = /* @__PURE__ */ ((MDL_METHOD2) => {
  MDL_METHOD2["Average"] = "Average";
  MDL_METHOD2["AverageIf"] = "AverageIf";
  MDL_METHOD2["ConditionalAverage"] = "ConditionalAverage";
  MDL_METHOD2["ConditionalCOUNT"] = "ConditionalCOUNT";
  MDL_METHOD2["ConditionalRate"] = "ConditionalRate";
  MDL_METHOD2["ConditionalSUM"] = "ConditionalSUM";
  MDL_METHOD2["COUNT"] = "COUNT";
  MDL_METHOD2["COUNTDISTINCT"] = "COUNTDISTINCT";
  MDL_METHOD2["COUNTDISTINCTIf"] = "COUNTDISTINCTIf";
  MDL_METHOD2["COUNTIf"] = "COUNTIf";
  MDL_METHOD2["MAX"] = "MAX";
  MDL_METHOD2["MAXIf"] = "MAXIf";
  MDL_METHOD2["MIN"] = "MIN";
  MDL_METHOD2["MINIf"] = "MINIf";
  MDL_METHOD2["SUM"] = "SUM";
  MDL_METHOD2["SUMIf"] = "SUMIf";
  MDL_METHOD2["Truncate"] = "Truncate";
  MDL_METHOD2["SafeDivide"] = "SafeDivide";
  return MDL_METHOD2;
})(MDL_METHOD || {});
var AGGREGATION_METHOD = /* @__PURE__ */ ((AGGREGATION_METHOD2) => {
  AGGREGATION_METHOD2["average"] = "STAVG";
  AGGREGATION_METHOD2["percentile"] = "STPERCENTILE";
  AGGREGATION_METHOD2["weightedAverage"] = "STWAVG";
  return AGGREGATION_METHOD2;
})(AGGREGATION_METHOD || {});
export {
  AGGREGATION_METHOD,
  MDL_METHOD
};
//# sourceMappingURL=MDLMetricDefinitions.js.map
